import { LatLon, WorldPoint } from '../domain/types.ts';

/**
 * Local Tangent / Equirectangular projection quanh center point (bán kính 100m - 500m).
 * Chuyển đổi chính xác tọa độ GPS Lat/Lon thực tế sang trục tọa độ Game Canvas (meters).
 */
export class Projection {
  private static readonly METERS_PER_DEGREE_LAT = 111320;

  /**
   * Chuyển đổi lat/lon sang world meters relative với center
   */
  public static project(point: LatLon, center: LatLon): WorldPoint {
    const dLat = point.lat - center.lat;
    const dLon = point.lon - center.lon;

    const latRad = (center.lat * Math.PI) / 180;
    const metersPerDegreeLon = this.METERS_PER_DEGREE_LAT * Math.cos(latRad);

    const x = dLon * metersPerDegreeLon;
    const y = -dLat * this.METERS_PER_DEGREE_LAT; // Trục Y hướng lên (North = -y)

    return { x, y };
  }

  /**
   * Chuyển đổi ngược từ world meters về lat/lon
   */
  public static unproject(point: WorldPoint, center: LatLon): LatLon {
    const latRad = (center.lat * Math.PI) / 180;
    const metersPerDegreeLon = this.METERS_PER_DEGREE_LAT * Math.cos(latRad);

    const dLat = -point.y / this.METERS_PER_DEGREE_LAT;
    const dLon = point.x / metersPerDegreeLon;

    return {
      lat: center.lat + dLat,
      lon: center.lon + dLon,
    };
  }
}
